import { Box, useTheme } from "@mui/material";
import ResetPasswordForm from "../forms/ResetPasswordForm";

const ResetPasswordWrapper = () => {
  const theme = useTheme();
  const colors = theme.palette;

  return (
    <ResetPasswordForm />
  );
};

export default ResetPasswordWrapper;
